import CreateUser from "./CreateUser";
import AppBreadcrumb from "../../modules/layout/components/AppBreadcrumb";
import { useTranslation } from "react-i18next";
import AgentUsersList from "./AgentUsersList";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth, userHasRole } from "../../../setup/auth/authService";
import { ManageRoles, AdminWeb } from "../../constants/constants";

export default function ManageAccounts(){

    const { t } = useTranslation();
    const [showForm, setShowForm] = useState(false);
    const toggleForm = () => setShowForm((prev) => !prev);

    const { user } = useAuth();
    const [isManageRoles, setIsManageRoles] = useState(false);
    const [isAdminWeb, setIsAdminWeb] = useState(false);
      
    useEffect(() => {
      const checkUserRole = async () => {
        const hasManageRolesRole = await userHasRole(ManageRoles);
        const hasAdminWebRole = await userHasRole(AdminWeb);
        setIsManageRoles(hasManageRolesRole);
        setIsAdminWeb(hasAdminWebRole);
      };  
      if (user && !user.expired) {
        checkUserRole();
      }
    }, [user]);

    return(       
        <div className="container mt-4 gg-container-form">
          <AppBreadcrumb
            items={[ { title: t('Home'), href: '/' },
                     { title: t('ManageAccounts') },
                   ]}
          />

          <h3 className="mb-0">{t('ManageAccounts')}</h3>         
          {!showForm && (isManageRoles && isAdminWeb) && (
            <div className="mb-3 d-flex flex-column align-start">
             <div className="d-flex align-items-center mt-4 ">
              <button 
                className={`btn mb-3 gg-btn-submit`} 
                onClick={toggleForm}
              >
                {showForm ? t('Cancel') : t('CreateAgentUser')}
              </button>
            </div>            
          </div>
          )}
          {showForm && (
              <CreateUser onSuccess={() => { setShowForm(false) } } onCancel={() => { setShowForm(false) } }/>
            )}
          
          <AgentUsersList />
        </div>
    )

}